import BaseProxy from './BaseProxy';

class User extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/user', parameters);
    }

    async getUserLessonTopics(id) {
        return this.submit('get', `/lesson/${id}/topics`);
    }
}

export default User;



// WEBPACK FOOTER //
// ./src/api/User.js